// extracted by mini-css-extract-plugin
export var pageContainer = "_e-1";
export var settingsContent = "_e-0";